import { render, staticRenderFns } from "./MoveMenu.vue?vue&type=template&id=18cfd746&scoped=true&"
import script from "./MoveMenu.vue?vue&type=script&lang=js&"
export * from "./MoveMenu.vue?vue&type=script&lang=js&"
import style0 from "./MoveMenu.vue?vue&type=style&index=0&id=18cfd746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cfd746",
  null
  
)

export default component.exports